import React,{Component} from "react";


export default class RepoTasks extends Component{

    render() {
        return (
            <div>
                Repo tasks
            </div>
        );
    }
}